import { ReactNode, createContext, useContext, useState, useCallback } from 'react';

type LoadingContextType = {
    loadingKeys: string[];
    setLoading: (key: string) => void;
};

const LoadingContext = createContext<LoadingContextType | null>(null);

function LoadingProvider({ children }: { children: ReactNode }) {
    const [loadingKeys, setLoadingKeys] = useState<string[]>([]);

    const setLoading = useCallback((key: string) => {
        setLoadingKeys(keys => {
            const index = keys.indexOf(key);
            if (index > -1) {
                keys.splice(index, 1);
            } else {
                keys.push(key);
            }
            return keys;
        });
    }, []);

    return (
        <LoadingContext.Provider value={{ loadingKeys, setLoading }}>
            <div className=' absolute h-[5px] w-full' />
            {children}
        </LoadingContext.Provider>
    );
}

function useLoadingContext() {
    const context = useContext(LoadingContext);

    if (!context) {
        throw Error('Loading context not found');
    }
    return context;
}

function useLoading({ keys }: { keys: string[] }) {
    const context = useContext(LoadingContext);

    if (!context) {
        throw Error('Loading context not found');
    }

    const { loadingKeys } = context;

    return loadingKeys.some(currentLoadingKey => keys.includes(currentLoadingKey));
}

export { LoadingProvider, useLoading, useLoadingContext };
